import { render, staticRenderFns } from "./AppMain.vue?vue&type=template&id=f5f1a6dc&scoped=true"
import script from "./AppMain.vue?vue&type=script&lang=js"
export * from "./AppMain.vue?vue&type=script&lang=js"
import style0 from "./AppMain.vue?vue&type=style&index=0&id=f5f1a6dc&prod&scoped=true&lang=css"
import style1 from "./AppMain.vue?vue&type=style&index=1&id=f5f1a6dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f1a6dc",
  null
  
)

export default component.exports